import React from "react"
import { ChildrenProps } from "../@types/CapioWeb/core"

interface AlertsContextProps {
	hideAlerts: boolean
	setHideAlerts?: React.Dispatch<React.SetStateAction<boolean>>
}

export const AlertsContext = React.createContext<AlertsContextProps>({
	hideAlerts: false,
})

export const AlertsContextProvider: React.FC<ChildrenProps> = (props) => {
	const [hideAlerts, setHideAlerts] = React.useState(false)

	return (
		<AlertsContext.Provider
			value={{ hideAlerts: hideAlerts, setHideAlerts: setHideAlerts }}
		>
			{props.children}
		</AlertsContext.Provider>
	)
}
